import { readSettingAcumulatedList } from '@/api/point/read';
import { ChangeEvent, Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Unstable_Grid2';
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from '@mui/material';
import { AddIndexPointAccumulatedListType, ResReadPointAccumulatedListType } from '@/types';
import RegisterAccumulated from '@/component/point/accumulated/register';
import { compareArrays } from '@/lib/Compare';
import { updatePointAccumulated } from '@/api/point/update';
import { sleep } from '@/lib/util';
import Loading from '@/component/mui/Backdrop';
import { toast } from 'react-toastify';

export default function PointSettingAccumulatedList({ settingId, refresh }: { settingId: string; refresh: number }) {
  console.log(settingId);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState<AddIndexPointAccumulatedListType[] | []>([]);
  const [oldList, setOldList] = useState<AddIndexPointAccumulatedListType[] | []>(list);

  useEffect(() => {
    if (!settingId) {
      navigate('/point-setting-list');
    }

    return () => {};
  }, [settingId, navigate]);

  useEffect(() => {
    (async () => {
      const re = await readSettingAcumulatedList(settingId);
      if (re.status !== 200) {
        return;
      }
      const list: AddIndexPointAccumulatedListType[] = re.data.map(
        (item: ResReadPointAccumulatedListType, index: number) => ({
          index: index,
          ...item,
        }),
      );
      setList(list);
      setOldList(list);
    })();
    return () => {};
  }, [refresh]);

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
    const { name, value } = e.target;
    if (!name) {
      return;
    }
    if (!list || !oldList) {
      return;
    }
    console.log(list[index]);
    setList((prev) =>
      prev
        ? prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  [name]: value,
                }
              : item,
          )
        : prev,
    );
    // onSubmitUpdate();
    // setList((prevList) =>
    //   prevList
    //     ? prevList.map((item) =>
    //         item.count === count
    //           ? {
    //               ...item,
    //               [name]: value,
    //             }
    //           : item,
    //       )
    //     : prevList,
    // );

    // setSettings((prev: any) => ({
    //   ...prev,
    //   [name]: value,
    // }));
  };
  const onSubmitUpdate = async () => {
    if (!list || !oldList) {
      return;
    }
    setIsLoading(true);
    const datas = compareArrays(list, oldList); // .filter((item) => Object.keys(item).length > 0);
    console.log(datas);
    if (!datas) {
      return;
    }

    let arr = [];
    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      if (Object.keys(datas[i]).length > 0) {
        const temp = {
          accumId: element.accumId,
          ...datas[i],
        };
        arr.push(temp);
      }
    }
    console.log(arr);
    const failedList = [];
    for (const iter of arr) {
      try {
        await updatePointAccumulated(iter);
        await sleep(1000);
      } catch (e) {
        failedList.push(iter);
      }
    }
    setIsLoading(false);
    if (failedList.length > 0) {
      toast.error(`${failedList.length}건 실패하였습니다.`);
    } else {
      toast.success('성공');
    }
  };

  return (
    <>
      {list[0] && (
        <>
          <Grid container spacing={3}>
            <Grid md={6} xs={12}>
              <Typography variant="h6">season: {list[0].season}</Typography>
            </Grid>
            <Grid xs={6}>
              <Typography variant="h6">code: {list[0].code}</Typography>
            </Grid>
          </Grid>
        </>
      )}

      <Divider />
      <Box mb={3} />
      {list.length > 0 && (
        <>
          {list.map((item: AddIndexPointAccumulatedListType) => (
            <Fragment key={item.index}>
              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <Typography variant="h6">No.{item.count}</Typography>
                </Grid>
                {/* <Grid xs={6}>
                  <Button onClick={() => onSubmitUpdate()}>변경</Button>
                </Grid> */}
              </Grid>

              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>point</InputLabel>
                    <OutlinedInput
                      type="text"
                      value={item.accPoint}
                      label="accPoint"
                      name="accPoint"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                    <FormHelperText>※ 목표 포인트</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid md={6} xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel>Title</InputLabel>
                    <OutlinedInput
                      value={item.title}
                      label="title"
                      name="title"
                      onChange={(e) => handleChangeValue(e, item.index)}
                    />
                    <FormHelperText>※ 포인트 게임이 동일할 때 같은 코드</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Box mb={2} />
              <TextField
                name="describe"
                id="describe"
                label="describe"
                multiline
                rows={1}
                value={item.describe ?? ''}
                onChange={(e) => handleChangeValue(e, item.index)}
              />
              <FormHelperText>※ [메인화면] 게이지 안내 멘트</FormHelperText>
              <Box mb={2} />
              <TextField
                name="doneDescribe"
                id="doneDescribe"
                label="doneDescribe"
                multiline
                rows={1}
                value={item.doneDescribe ?? ''}
                onChange={(e) => handleChangeValue(e, item.index)}
              />
              <FormHelperText>※ [모달] 구간 완료 시 보상 멘트</FormHelperText>
              <Divider />
              <Box mb={5} />
            </Fragment>
          ))}
          <Button variant="outlined" fullWidth onClick={onSubmitUpdate}>
            변경
          </Button>
        </>
      )}
      <Loading isLoading={isLoading} />
    </>
  );
}

/**
 * 등록, 리스트
 *
 * 등록 할 때 멘트도 함께 나오게 해야 한다
 *
 * 화면 구성은??
 * 수량, usdt, 설명1, 설명2
 *
 */
